export default __webpack_public_path__ + "static/media/2022_November_See.038c6c77.webp";